/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from "@wordpress/block-editor";

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({ attributes }) {
  const { loaderBackground, loaderColor, loaders, borderRadius, loaderSize, loadingTime, spinnerWidth } = attributes
  const hexToRgb = (hex) => {
    if (!hex || hex[0] !== "#" || (hex.length !== 7 && hex.length !== 4)) {
      return "246, 207, 244";
    }

    let r, g, b;

    if (hex.length === 7) { // #RRGGBB format
      r = parseInt(hex.slice(1, 3), 16);
      g = parseInt(hex.slice(3, 5), 16);
      b = parseInt(hex.slice(5, 7), 16);
    } else { // #RGB format
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    }

    return `${r}, ${g}, ${b}`;
  };

  const getStyles = () => ({
    '--loader-background-color': loaderBackground,
    '--loader-color': loaderColor,
    '--loader-size': `${loaderSize}px`,
    '--loader-radius': `${borderRadius}%`,
    '--spinner-width': `${spinnerWidth}px`,
    '--loader-rgb': hexToRgb(loaderColor)
  });

  return (
    <div {...useBlockProps.save()}>
      <div id="templazee-loader" className="templazee loader" style={getStyles()} data-load={loadingTime}>
        <div className={`loader-animation-save ${loaders || 'inwardSpiral'}`}> </div>
      </div>
    </div>
  );
}
